import { LitElement, html, nothing, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Producer } from '../util/api';
import { consume } from '@lit/context';
import { breakpointContext } from '../contexts/breakpoint';
import { BREAKPOINT } from '../util/breakpoints';
import { SOURCE } from '../util/source';
import { sourceContext } from '../contexts/source';

@customElement('rq-agent-banner')
export class AgentBanner extends LitElement {
    static styles = css`
        .wrapper {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 8px;
        }
        .icon {
            color: var(--lh-color-neutral-white, #ffffff);
        }
    `;
    @property({ type: Object })
    agent?: Producer;

    @consume({ context: breakpointContext, subscribe: true })
    breakpoint!: BREAKPOINT;

    @consume({ context: sourceContext, subscribe: true })
    source!: SOURCE;

    get isMobile() {
        return this.breakpoint === BREAKPOINT.PHONE || this.breakpoint === BREAKPOINT.TABLET;
    }

    render() {
        if (!this.agent) return nothing;
        const initials = (this.agent.firstName?.[0] || '') + (this.agent.lastName?.[0] || '');
        let label = 'Your Agent:';
        if (this.source === SOURCE.EMBEDDED_AGENT) {
            label = 'Acting as:';
        } else if (this.agent) {
            label = 'Logged in as:';
        }
        return html`<lh-container
            padding-top="md"
            padding-bottom="md"
            theme="primary-dark"
            spacing="none"
            gutters=${this.isMobile ? 'sm' : 'sm'}
            content-width="xxl"
        >
            <div class="wrapper">
                <span class="icon"><lh-avatar initials=${initials}></lh-avatar></span>
                <lh-typography
                    ><strong>${label}</strong> ${this.agent.firstName} ${this.agent.lastName} |
                    ${this.agent.email}</lh-typography
                >
            </div>
        </lh-container>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-agent-banner': AgentBanner;
    }
}
